function AggregatedRemoveService(storage) {
	

	function markForDelete(typeName, item) {
		var itemsMarkedForDelete = storage.getItem('itemsMarkedForDelete') || {} ; 
		itemsMarkedForDelete[typeName] = itemsMarkedForDelete[typeName] || [] ; 
		itemsMarkedForDelete[typeName].push(item);
		storage.setItem('itemsMarkedForDelete', itemsMarkedForDelete) ; 
	}

	function getList() {
		var items = storage.getItem('itemsMarkedForDelete');
		if ( ! Object.keys(items) )
			items = null ; 

		return items;
	}

	function clear(typeName) {
		var itemsMarkedForDelete = storage.getItem('itemsMarkedForDelete') || {} ; 
		if ( itemsMarkedForDelete[typeName])
			delete itemsMarkedForDelete[typeName] ; 
		storage.setItem('itemsMarkedForDelete', itemsMarkedForDelete) ; 
	}

	return {
		markForDelete: markForDelete,
		getList: getList,
		clear: clear,
	}
}